import api from "@/api";

export default {
  namespaced: true,
  state: {
    subjects: [],
    currentSubject: null,
    isLoading: false,
    error: null,
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      perPage: 10,
      from: 0,
      to: 0,
    },
    filters: {
      search: "",
      class_id: null,
    },
  },
  mutations: {
    SET_SUBJECTS(state, subjects) {
      state.subjects = subjects;
    },
    SET_CURRENT_SUBJECT(state, subject) {
      state.currentSubject = subject;
    },
    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_PAGINATION(state, pagination) {
      state.pagination = pagination;
    },
    SET_FILTERS(state, filters) {
      state.filters = filters;
    },
    ADD_SUBJECT(state, subject) {
      state.subjects.unshift(subject);
    },
    UPDATE_SUBJECT(state, updatedSubject) {
      const index = state.subjects.findIndex((s) => s.id === updatedSubject.id);
      if (index !== -1) state.subjects.splice(index, 1, updatedSubject);
    },
    DELETE_SUBJECT(state, subjectId) {
      state.subjects = state.subjects.filter((s) => s.id !== subjectId);
    },
  },
  actions: {
async fetchSubjects({ commit }, { page = 1, per_page = 10, search = '', class_id = null } = {}) {
  commit("SET_LOADING", true);
  try {
    const response = await api.get("/subjects", {
      params: {
        page,
        per_page,
        search,
        class_id
      }
    });

    commit("SET_SUBJECTS", response.data.data);
    commit("SET_PAGINATION", {
      currentPage: response.data.meta.current_page,
      totalPages: response.data.meta.last_page,
      totalItems: response.data.meta.total,
      perPage: response.data.meta.per_page,
      from: response.data.meta.from,
      to: response.data.meta.to,
    });
  } catch (error) {
    commit("SET_ERROR", error.response?.data?.message || error.message);
    throw error;
  } finally {
    commit("SET_LOADING", false);
  }
},

    fetchSubject({ commit }, id) {
      commit("SET_LOADING", true);
      return api
        .get(`/subjects/${id}`)
        .then((response) => {
          commit("SET_CURRENT_SUBJECT", response.data.data);
        })
        .catch((error) => {
          commit("SET_ERROR", error.response?.data?.message || error.message);
          throw error;
        })
        .finally(() => commit("SET_LOADING", false));
    },

    createSubject({ commit }, formData) {
      commit("SET_LOADING", true);

      return api
        .post("/subjects", formData)
        .then((response) => {
          commit("ADD_SUBJECT", response.data.data);
          return response.data;
        })
        .catch((error) => {
          if (error.response && error.response.status === 422) {
            throw error.response.data.errors;
          }
          commit("SET_ERROR", error.response?.data?.message || error.message);
          throw error;
        })
        .finally(() => commit("SET_LOADING", false));
    },

    updateSubject({ commit }, { id, subjectData }) {
      commit("SET_LOADING", true);

      return api
        .put(`/subjects/${id}`, subjectData)
        .then((response) => {
          commit("UPDATE_SUBJECT", response.data.data);
          return response.data;
        })
        .catch((error) => {
          if (error.response && error.response.status === 422) {
            throw error.response.data.errors;
          }
          commit("SET_ERROR", error.response?.data?.message || error.message);
          throw error;
        })
        .finally(() => commit("SET_LOADING", false));
    },

    deleteSubject({ commit }, id) {
      commit("SET_LOADING", true);
      return api
        .delete(`/subjects/${id}`)
        .then(() => {
          commit("DELETE_SUBJECT", id);
          return Promise.resolve();
        })
        .catch((error) => {
          commit("SET_ERROR", error.response?.data?.message || error.message);
          return Promise.reject(error);
        })
        .finally(() => commit("SET_LOADING", false));
    },

    setFilters({ commit, dispatch }, filters) {
      commit("SET_FILTERS", filters);
      dispatch("fetchSubjects");
    },
  },
  getters: {
    subjects: (state) => state.subjects,
    subject: (state) => state.currentSubject,
    isLoading: (state) => state.isLoading,
    error: (state) => state.error,
    pagination: (state) => state.pagination,
  },
};
